// src/hooks/useGlobalSearch.js
import { useState, useEffect, useCallback } from 'react';
import { useAppData } from '../context/AppDataContext';

const EXCLUDED_ORDER_STATUSES = ['complete', 'order complete', 'on hold', 'cancelled'];

export const useGlobalSearch = () => {
  const { allOrders, clients, loaded } = useAppData();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState({ orders: [], clients: [] });

  // Search functionality
  useEffect(() => {
    if (!searchQuery.trim() || !loaded) {
      setSearchResults({ orders: [], clients: [] });
      return;
    }

    const query = searchQuery.toLowerCase().trim();
    
    const matchingOrders = allOrders.filter(order => {
      const status = (order.status || '').toLowerCase();
      if (EXCLUDED_ORDER_STATUSES.includes(status)) return false;

      const jobNumber = (order.jobNumber || order.id || '').toLowerCase();
      const dealershipName = (order.dealershipName || '').toLowerCase();
      
      return jobNumber.includes(query) || 
             dealershipName.includes(query) || 
             status.includes(query);
    }).slice(0, 8);

    const matchingClients = clients.filter(client => {
      const name = (client.name || '').toLowerCase();
      const city = (client.city || '').toLowerCase();
      const state = (client.state || '').toLowerCase();
      
      return name.includes(query) || 
             city.includes(query) || 
             state.includes(query);
    }).slice(0, 8);

    setSearchResults({ orders: matchingOrders, clients: matchingClients });
  }, [searchQuery, allOrders, clients, loaded]);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
    setSearchResults({ orders: [], clients: [] });
  }, []);

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    loading: !loaded,
    clearSearch
  };
};